import { createSlice } from "@reduxjs/toolkit";

const emptyItem = { account: "", amount: "", remarks: "", qty: "1" };

export const counterCashDepositSlice = createSlice({
  name: "counterCashDeposit",
  initialState: {
    loading: false,
    list: [],
    model: false,
    viewModel: false,
    viewData: {},
    drawer: false,
    listCount: 0,
    error_msg: null,
    rowdata: { items: [{ ...emptyItem }], deletedItems: [] },
    params: {
      start_date: "",
      end_date: "",
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
      counter: "",
    },
  },
  reducers: {
    getList: (state) => ({ ...state, loading: true }),
    listSuccessful: (state, action) => ({
      ...state,
      listCount: action.payload.response.count,
      list: action.payload.response.results,
      loading: false,
      params: {
        ...state.params,
        no_of_pages: Math.ceil(action.payload.response.count / state.params.page_size),
      },
    }),
    addRecord: (state) => ({ ...state, loading: true }),
    addRecordSuccessful: (state) => ({
      ...state,
      loading: false,
      model: false,
      rowdata: { items: [{ ...emptyItem }], deletedItems: [] },
    }),
    editRecord: (state, action) => ({
      ...state,
      model: true,
      rowdata: {
        id: action.payload.id,
        items: [{ ...emptyItem }],
        deletedItems: [],
      },
    }),
    viewRecord: (state, action) => ({
      ...state,
      viewModel: true,
      viewData: action.payload,
    }),
    isViewModelVisible: (state, action) => ({
      ...state,
      viewModel: action.payload,
      ...(!action.payload && { viewData: {} }),
    }),
    getRecordById: (state) => ({ ...state, loading: true }),
    getRecordByIdSuccessful: (state, action) => {
      const apiItems = action.payload.ccditems || [];
      const items = apiItems.length ? apiItems : [{ ...emptyItem }];
      return {
        ...state,
        loading: false,
        rowdata: {
          id: action.payload.id,
          document_no: action.payload.code,
          date: action.payload.date,
          counter_id: action.payload.counter?.id,
          cash_bank_ac: action.payload.cash_bank_ac,
          division_id: action.payload.division?.id,
          state_id: action.payload.state?.id,
          firm_company: action.payload.firm_company,
          branch_account: action.payload.branch_account,
          bank_account: action.payload.bank_account,
          bank_account_choice: action.payload.bank_account_choice,
          bank_account_master_id: action.payload.bank_account_master?.id,
          narration: action.payload.narration,
          attachment: action.payload.attachment,
          items,
          deletedItems: [],
        },
      };
    },
    deleteRecord: (state) => ({ ...state, loading: false }),
    InputChangeValue: (state, action) => ({
      ...state,
      rowdata: { ...state.rowdata, [action.payload.key]: action.payload.value },
    }),
    ItemInputChangeValue: (state, action) => {
      const { index, key, value } = action.payload;
      const items = [...(state.rowdata.items || [])];
      items[index] = { ...items[index], [key]: value };
      return { ...state, rowdata: { ...state.rowdata, items } };
    },
    addItemRow: (state) => ({
      ...state,
      rowdata: { ...state.rowdata, items: [...(state.rowdata.items || []), { ...emptyItem }] },
    }),
    removeItemRow: (state, action) => {
      const removedItem = (state.rowdata.items || [])[action.payload];
      const items = (state.rowdata.items || []).filter((_, i) => i !== action.payload);
      const deletedItems = [...(state.rowdata.deletedItems || [])];
      if (removedItem?.id) {
        deletedItems.push(removedItem);
      }
      return {
        ...state,
        rowdata: { ...state.rowdata, items: items.length ? items : [{ ...emptyItem }], deletedItems },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return { ...state, model: false, rowdata: { items: [{ ...emptyItem }], deletedItems: [] } };
      }
      return { ...state, model: true };
    },
    SetParams: (state, action) => ({ ...state, params: action.payload }),
    isDrawerVisible: (state, action) => ({ ...state, drawer: action.payload }),
    counterCashDepositApprove: (state) => ({ ...state, loading: true }),
    counterCashDepositApprovalSuccessful: (state) => ({ ...state, loading: false }),
    fsyncStatusUpdate: (state) => ({ ...state, loading: true }),
    FilterInputChangeValue: (state, action) => ({
      ...state,
      params: { ...state.params, [action.payload.key]: action.payload.value },
    }),
    apiError: (state, action) => ({ ...state, loading: false, error_msg: action.payload }),
  },
});

export const {
  getList,
  listSuccessful,
  addRecord,
  addRecordSuccessful,
  editRecord,
  viewRecord,
  isViewModelVisible,
  deleteRecord,
  getRecordById,
  getRecordByIdSuccessful,
  InputChangeValue,
  ItemInputChangeValue,
  addItemRow,
  removeItemRow,
  isModelVisible,
  SetParams,
  isDrawerVisible,
  counterCashDepositApprove,
  counterCashDepositApprovalSuccessful,
  fsyncStatusUpdate,
  FilterInputChangeValue,
  apiError,
} = counterCashDepositSlice.actions;

export default counterCashDepositSlice.reducer;
